import React, { useState } from "react";
import { InputPadrao, BtnPadrao } from "../../components/Base";
import { connect } from 'react-redux'
import { logIn, logOut, fetchNoAuth } from '../../actions'
import Logo from "../../assets/logo.png";
// import { Container } from './styles';
import { message, Input } from 'antd';

function Login(props) {

  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    console.log('trestes');
    event.preventDefault();
    login();
  }

  const login = () => {

    if (loading) {
      return;
    }

    props.logOut();
    setLoading(true);

    // if (user === 'teste' && pass === 'alvo135') {
    //   let data = { userName: user, tokenId: 'token', refreshToken: 'rf' }
    //   props.logIn({ user: data.userName, tokenId: data.tokenId, refreshToken: data.refreshToken });
    //   setLoading(false);
    // }
    // else {
    //   setLoading(false);
    //   message.error('Usuário/Senha inválidos');
    // }

    props.fetchNoAuth().post('/account/login', { userName: user, pass })
      .then(function ({ data }) {
        setLoading(false);
        props.logIn({ user: data.userName, tokenId: data.tokenId, refreshToken: data.refreshToken });
        props.history.push('/');
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        message.error('Usuário/Senha inválidos');
      });
  }

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ width: "100%", height: "100vh", backgroundColor: "#f7f7f7", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div style={{ width: 450, backgroundColor: "#fff", borderRadius: 10, boxShadow: "0 0 10px #bbbb", padding: "40px 50px", display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "center", }}>
          <img src={Logo} style={{ maxWidth: 100, marginBottom: 50, marginTop: 10 }} alt="logo"></img>
          <div>
            <Input placeHolder="Usuario" style={{ margin: "20px 0", marginTop: -30 }} value={user} onChange={e => setUser(e.target.value)} />
            <Input placeHolder="Senha" type="password" value={pass} onChange={e => setPass(e.target.value)} />
            <div style={{ marginTop: 30, display: "flex", justifyContent: "space-between" }}>
              <a>Esqueci minha senha</a>
              <BtnPadrao style={{ backgroundColor: "#ff8000", color: "#fff", width: 130, borderRadius: 5, fontSize: 14, letterSpacing: 1 }} onClick={login} loading={loading}>Entrar</BtnPadrao>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default connect(null, { logIn, logOut, fetchNoAuth })(Login);
